import { KuxEventWithParam } from './events';

export enum DeviceAction {
  reboot = 'REBOOT',
  restart = 'RESTART',
  shutdown = 'SHUTDOWN',
  softwareUpdate = 'SW_UPDATE',
  custom1 = 'CUSTOM_1',
  custom2 = 'CUSTOM_2',
  applicationStart = 'SW_START',
  deviceStart = 'DEVICE_START',
}

export enum InitiatedBy {
  User = 'USER',
  Device = 'DEVICE',
}

export class DeviceActionEventArgs extends KuxEventWithParam {
  readonly action: DeviceAction;

  constructor(action: DeviceAction, data?: Partial<KuxEventWithParam>) {
    super('deviceAction', data);
    this.action = action;
  }
}

class DeviceInitiatedByEvent extends DeviceActionEventArgs {
  constructor(action: DeviceAction, initiatedBy: InitiatedBy) {
    super(action, {
      param1: initiatedBy,
    });
  }
}

export class DeviceShutdownEvent extends DeviceInitiatedByEvent {
  constructor(initiatedBy: InitiatedBy) {
    super(DeviceAction.shutdown, initiatedBy);
  }
}

export class DeviceRestartEvent extends DeviceInitiatedByEvent {
  constructor(initiatedBy: InitiatedBy) {
    super(DeviceAction.restart, initiatedBy);
  }
}

export class DeviceApplicationStartEvent extends DeviceActionEventArgs {
  constructor(refresh = false) {
    super(DeviceAction.applicationStart, {
      param1: refresh ? 'refresh' : undefined,
    });
  }
}
